<template>
  <div class="page-header">
    <el-row>
      <el-col :span="6">
        <button class="toggle-btn" @click="expand">
        <icon name="menu"></icon>
        </button>
        <span class="page-title">{{ $t(title) }}</span>
      </el-col>
      <slot></slot>
    </el-row>
  </div>
</template>
<script>
export default {
  computed: {
    title () {
      return this.$route.meta.title
    }
  },
  methods: {
    expand () {
      this.$emit('expand')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@xpeng/element-styles/src/variables.scss";
@import "@xpeng/element-styles/src/mixin.scss";

.page-header {
  @include clearfix;
  height: 49px;
  line-height: 49px;
  padding: 0 32px 0 16px;
  background: #f7f7f7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  .toggle-btn{
    background: none;
    border: none;
    outline: none;
    margin-right: 16px;
    &:hover {
      color: $primaryColor;
      cursor: pointer;
    }
    svg {
      width: 16px;
      height: 16px;
    }
  }
  .page-title {
    font-size: 18px;
    color: #222222;
    font-weight: 500;
  }
}
</style>
